<button
	mat-button
	[matMenuTriggerFor]="logMenu"
	*ngIf="_order.value.log && _order.value.log[0]"
	(click)="_clickField()"
	[class.small]="small"
	class="log-button">
	<img class="log" src="assets/images/log2.svg" alt="View log">
	<ng-container *ngIf="!small">
		<span *ngIf="_order.value.log[0].item">
			{{ formatLogItem(_order.value.log[0].item) }}&nbsp;&ndash;&nbsp;
		</span>
		<span style="text-transform: uppercase !important;">
			{{ _order.value.log[0].initials }}&nbsp;&ndash;&nbsp;
			{{ _order.value.log[0].date | date: 'MM/dd/yyyy' : 'PST' }}
		</span>
	</ng-container>
</button>
<mat-menu #logMenu="matMenu" panelClass="log-menu-panel">
	<mat-list role="list" dense>
		<mat-list-item role="listitem" *ngFor="let log of _order.value.log; let j=index" style="text-transform: uppercase; font-size:smaller;">
			<span class="log-row">
				<ng-container *ngIf="log.item">{{ formatLogItem(log.item) }}&nbsp;&ndash;&nbsp;</ng-container>
				{{ log.initials }}
				&nbsp;&ndash;&nbsp;{{ log.date | date: 'MM/dd/yyyy': 'PST' }}
				<ng-container *ngIf="log.notes">&nbsp;&ndash;&nbsp;{{ log.notes }}</ng-container>
			</span>
		</mat-list-item>
	</mat-list>
</mat-menu>
